import React, { useEffect, useState } from 'react';
import { FaWhatsapp, FaTelegramPlane } from 'react-icons/fa';
import Icon from '../../../components/AppIcon';
import { SOCIALS, WHATSAPP_DISPLAY, openTelegram } from '../../../config/site';

const PREVIEW = [
  { from: 'you', text: 'Hi, I want to open a Nitin Online Book ID 🙏', delay: 0 },
  { from: 'desk', text: 'Namaste! Welcome. Your ID takes about 2 minutes — which game do you play most?', delay: 1400 },
  { from: 'you', text: 'Teen Patti mostly. And I need the app download link.', delay: 2800 },
  { from: 'desk', text: 'Done ✅ ID created, ₹ welcome bonus added, and the official app link is on its way.', delay: 4200 },
];

const ContactHero = ({ onWhatsAppClick }) => {
  const [shown, setShown] = useState(0);

  useEffect(() => {
    const timers = PREVIEW.map((m, i) => setTimeout(() => setShown(i + 1), m.delay + 600));
    const loop = setInterval(() => {
      setShown(0);
      PREVIEW.forEach((m, i) => setTimeout(() => setShown(i + 1), m.delay + 600));
    }, 14000);
    return () => {
      timers.forEach(clearTimeout);
      clearInterval(loop);
    };
  }, []);

  return (
    <section className="relative isolate overflow-hidden py-16 lg:py-24">
      <span className="aurora left-[-10%] top-[-6%] h-[26rem] w-[26rem] bg-wa-green/30" aria-hidden="true" />
      <span className="aurora right-[-8%] top-[12%] h-[26rem] w-[26rem] bg-royal-gold/25" aria-hidden="true" />
      <div className="absolute inset-0 grid-lines" aria-hidden="true" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-center gap-14 lg:grid-cols-[1.05fr_0.95fr]">
          <div className="animate-rise text-center lg:text-left">
            <span className="badge-pill mx-auto lg:mx-0">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-wa-green opacity-75" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-wa-green" />
              </span>
              3 gaming experts online now
            </span>

            <h1 className="mt-6 font-heading text-hero font-bold text-white [text-wrap:balance]">
              The VIP desk is <span className="gold-text">one message away</span>
            </h1>

            <div className="mt-5 inline-flex items-center gap-2 rounded-full border border-royal-gold/35 bg-royal-gold/12 px-4 py-2 text-sm font-semibold text-royal-gold shadow-[0_1px_0_rgba(255,255,255,0.14)_inset] lg:justify-start">
              <Icon name="ShieldCheck" size={15} color="#F0C24B" />
              A Govt. of India Undertaking · Govt verified
            </div>

            <div className="mt-4 inline-flex items-center rounded-full border border-white/10 bg-white/[0.06] px-4 py-2 text-sm font-semibold uppercase tracking-[0.2em] text-white/80 backdrop-blur-royal lg:justify-start">
              NITINN ONLINE Book - Honours Your Trust
            </div>

            <p className="mx-auto mt-6 max-w-xl text-body-lg text-white/65 lg:mx-0">
              No ticket queues, no hold music, no bots pretending to be people. Message {WHATSAPP_DISPLAY} on
              WhatsApp and a certified Nitin Online Book expert handles your login, sign up, app download, deposits
              and payouts personally.
            </p>

            <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row lg:justify-start">
              <button onClick={onWhatsAppClick} className="btn-3d btn-3d-wa w-full sm:w-auto">
                <FaWhatsapp size={20} /> Start WhatsApp chat
              </button>
              <button onClick={openTelegram} className="btn-3d btn-3d-ghost w-full sm:w-auto">
                <FaTelegramPlane size={18} /> Telegram VIP channel
              </button>
            </div>

            <div className="mt-8 grid grid-cols-3 gap-3">
              {[
                { v: '< 2 min', l: 'Average reply' },
                { v: '24 × 7', l: 'Always open' },
                { v: '4.9/5', l: 'Support rating' },
              ].map((s) => (
                <div key={s.l} className="stat-3d">
                  <div className="font-display text-lg font-bold gold-text">{s.v}</div>
                  <div className="mt-1 text-[0.6rem] uppercase tracking-[0.14em] text-white/45">{s.l}</div>
                </div>
              ))}
            </div>

            <p className="mt-6 text-xs text-white/40">
              Also on {SOCIALS.email} · {SOCIALS.city}
            </p>
          </div>

          {/* Chat preview mock */}
          <div className="perspective mx-auto w-full max-w-sm">
            <div
              className="preserve-3d relative"
              style={{ transform: 'rotateX(6deg) rotateY(-10deg)' }}
            >
              <div className="absolute -inset-4 rounded-[36px] bg-wa-green/20 blur-2xl" aria-hidden="true" />

              <div className="relative overflow-hidden rounded-[30px] border border-white/12 bg-[#0B0F14] p-3 shadow-[0_50px_90px_-40px_rgba(0,0,0,1)]">
                {/* Phone header */}
                <div className="flex items-center gap-3 rounded-[22px] bg-gradient-to-r from-[#128C4B] to-[#0A6634] px-4 py-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full border-2 border-white/60 bg-gradient-to-br from-[#FFF0B8] to-[#C4901A]">
                    <Icon name="Crown" size={18} color="#0B0B14" />
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="truncate font-display text-sm font-semibold text-white">Nitin Online Book · VIP Desk</p>
                    <p className="text-[0.66rem] text-white/80">online · typing…</p>
                  </div>
                  <Icon name="Phone" size={16} className="text-white/80" />
                </div>

                {/* Messages */}
                <div
                  className="mt-3 min-h-[17rem] space-y-2.5 rounded-[22px] p-4"
                  style={{
                    backgroundColor: '#070A0E',
                    backgroundImage: 'url("/assets/images/gen/royal-pattern.svg")',
                    backgroundSize: '120px 120px',
                  }}
                >
                  {PREVIEW.slice(0, shown).map((m) => (
                    <div key={m.text} className={`flex animate-rise ${m.from === 'you' ? 'justify-end' : 'justify-start'}`}>
                      <div
                        className={`max-w-[86%] rounded-2xl px-3.5 py-2.5 text-[0.78rem] leading-relaxed shadow-[0_10px_20px_-14px_rgba(0,0,0,0.9)] ${
                          m.from === 'you'
                            ? 'rounded-br-md bg-[#0F5A38] text-white'
                            : 'rounded-bl-md border border-white/10 bg-[#141C23] text-white/90'
                        }`}
                      >
                        {m.text}
                        <span className="mt-1 block text-right text-[0.55rem] text-white/40">
                          {m.from === 'you' ? '✓✓' : ''} now
                        </span>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="mt-3 flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.05] px-4 py-2.5">
                  <Icon name="Smile" size={16} className="text-white/35" />
                  <span className="flex-1 text-[0.75rem] text-white/35">Message the VIP desk…</span>
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-wa-green">
                    <Icon name="Send" size={14} color="#04220F" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;
